<template>
    <v-dialog
        v-model="showDialog"
        persistent
        max-width="489"
    >
        <v-card style="padding: 0 0 20px 0; font-family: sans-serif;">
            <v-card-title class="teal darken-1 white--text">
                <v-icon class="white--text" style="font-size: 28px; margin-right: 5px; font-weight: 900;">
                    {{ mdiExclamationThick }}
                </v-icon><span style="letter-spacing: 2px; font-weight: 600;">IMPORTANT REMINDERS</span>
            </v-card-title>
            <v-card-text style="font-size: 16px; color: #333; letter-spacing: .7px; padding: 15px 38px 35px 38px">
                <p style="font-size: 25px; font-weight: 700; color: green"></p>
                <p>Upon billing, please include the following documents to facilitate the processing of payment:</p>
                <ol style="line-height: 28px;">
                    <li><b>Original copy of doctor's request for laboratory/procedure.</b></li>
                    <li><b>Out-Patient Procedure Authorization Form duly signed by the member and HMO representative.</b></li>
                </ol>
            </v-card-text>
            <v-card-actions style="height: 0;">
                <v-spacer />
                <v-btn
                    outlined
                    color="teal darken-1"
                    style="text-transform: none; width: 105px;"
                    :disabled="isConfirmed.isLoading"
                    @click="showDialog = false"
                >
                    CLOSE
                </v-btn>
                <v-btn
                    color="teal darken-3 white--text"
                    :loading="isConfirmed.isLoading"
                    style="text-transform: none; width: 105px; font-weight: 600"
                    @click="submitRequest"
                >
                    PROCEED
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiExclamationThick } from '@mdi/js'

export default {
    props: ['isConfirmed'],
    data: () => ({
        mdiExclamationThick
    }),
    computed: {
        showDialog: {
            get() {
                return this.isConfirmed.status
            },
            set() {
                this.$emit('closeConfirmSubmit')
            }
        }
    },
    methods: {
        submitRequest() {
            this.$emit('submitRequest')
        }
    }
}
</script>
